var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5352 19.2841C17.1935 19.6258 16.6395 19.6258 16.2978 19.2841L11.6311 14.6174C11.2894 14.2757 11.2894 13.7217 11.6311 13.38L16.2978 8.71331C16.6395 8.3716 17.1935 8.3716 17.5352 8.71331C17.8769 9.05502 17.8769 9.60904 17.5352 9.95075L13.4873 13.9987L17.5352 18.0466C17.8769 18.3884 17.8769 18.9424 17.5352 19.2841Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.000a6d83c654905dc20c374404a21c82.svg";
export { ForwardRef as ReactComponent };